import { defineStore } from "pinia";

import { RecruitmentCandidatesFiltersService } from "@core/services";
import { LocationOptionModel, BasicOptionModel } from "@core/models";
import {
  ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS,
  ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS,
  ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS,
  GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS,
  GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS,
  GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS,
} from "@etab/stores/types";

export const useRecruitmentCandidatesFiltersStore = defineStore("recruitmentCandidatesFilters", {
  // convert to a function
  state: () => ({
    languageOptions: [],
    experienceOptions: [],
    locationOptions: [],
  }),
  getters: {
    [GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS]: (state) => state.languageOptions.map((lang) => new BasicOptionModel(lang)),
    [GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS]: (state) => state.experienceOptions.map((xp) => new BasicOptionModel(xp)),
    [GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS]: (state) =>
      state.locationOptions.map((location) => new LocationOptionModel(location)),
  },
  actions: {
    async [ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS]() {
      if (this.languageOptions?.length === 0) {
        const options = await RecruitmentCandidatesFiltersService.getLanguageOptions();
        this.languageOptions = options;
      }
    },
    async [ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS]() {
      if (this.experienceOptions?.length === 0) {
        const options = await RecruitmentCandidatesFiltersService.getExperienceOptions();
        this.experienceOptions = options;
      }
    },
    async [ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS](city) {
      const options = await RecruitmentCandidatesFiltersService.getLocationOptions({ city });
      this.locationOptions = options;
    },
    // easily reset state using `$reset`
    clearRecruitmentCandidatesFiltersStore() {
      this.$reset();
    },
  },
});
